import type { PlayerId, SeatId } from "./ids.js";

export type PlayerInput = {
  tick: number;
  seq: number;
  seatId: SeatId;
  playerId: PlayerId | null;
  moveX: number;
  moveY: number;
  sprint: number;
  buttons: number;
};

export enum InputButton {
  Pass = 1 << 0,
  Shoot = 1 << 1,
  Poke = 1 << 2,
  StickLift = 1 << 3,
  BigHit = 1 << 4,
  Context = 1 << 5,
  Goalie = 1 << 6,
  LineCycleUp = 1 << 7,
  LineCycleDown = 1 << 8,
  LineSelect1 = 1 << 9,
  LineSelect2 = 1 << 10,
  LineSelect3 = 1 << 11,
  LineSelect4 = 1 << 12,
  StrategyDefensive = 1 << 13,
  StrategyOffensive = 1 << 14,
  GoaliePullToggle = 1 << 15,
  Pause = 1 << 16,
}

export const emptyInput: Readonly<PlayerInput> = Object.freeze({
  tick: 0,
  seq: 0,
  seatId: "P1",
  playerId: null,
  moveX: 0,
  moveY: 0,
  sprint: 0,
  buttons: 0,
});
